import React from 'react';

import { useClearByOnDemand, SUBMISSION_STATE } from '../Contexts/ClearByOnDemandProvider';
import ClearTicketReviewView from '../Components/ClearTicketReview';

const ClearTicketReview = () => {
  const [
    submissionState,
    { images = [], screenshot, bookNo, pageNo, questionNo, question } = {},
    { goToFillingFormStep, goToCompletedStep },
  ] = useClearByOnDemand();
  const imageSources = images.map((image) => image?.source);
  const imageSourcesWithScreenshot = screenshot
    ? [screenshot?.source, ...imageSources]
    : imageSources;
  return (
    <ClearTicketReviewView
      images={imageSourcesWithScreenshot}
      bookNo={bookNo}
      pageNo={pageNo}
      questionNo={questionNo}
      question={question}
      onSend={goToCompletedStep}
      onBack={() => goToFillingFormStep()}
      loading={submissionState === SUBMISSION_STATE.SUBMITTING}
    />
  );
};

export default ClearTicketReview;
